export { default as LifestylesIndexPageBreadcrumbs } from './LifestylesIndexPageBreadcrumbs';
